// The word inside "(copy)" in each language a name may have been made in
// (designs.page.copyName; copyName.test.ts keeps them in step with the files).
export const COPY_WORDS: readonly string[] = ['copy', 'nüsxə', 'копия']
const WORDS = COPY_WORDS
const escaped = WORDS.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
const SUFFIX = new RegExp(`\\s*\\((?:${escaped})(?:\\s+\\d+)?\\)\\s*$`, 'iu')

/** A design's name without a trailing copy mark in any language, "(copy)" or
 *  "(копия 3)": duplicating a copy names it after the original, and the server
 *  numbers it ("X (copy 2)") rather than piling up "(copy) (copy)". */
export function copyBase(name: string): string {
  const base = name.replace(SUFFIX, '').trim()
  return base || name.trim()
}

/** layout.MaxNameRunes: the longest name a design may be given. */
export const MAX_DESIGN_NAME = 120

/** A copy's name within the limit: the original's name shortened to leave room for
 *  the copy mark (shape is the phrase with an empty name) and the server's number. */
export function copyNameWithin(name: string, shape: (name: string) => string): string {
  const room = MAX_DESIGN_NAME - Array.from(shape('')).length - 4
  const runes = Array.from(name)
  return shape(runes.length > room ? runes.slice(0, Math.max(room, 0)).join('').trim() : name)
}
